import { compose, defaultTo, prop, __ } from "ramda";

export const CONNECTION_TYPE_XMLFILE = 'xmlFile';
export const CONNECTION_TYPE_SHPLIST = 'shpList';
export const CONNECTION_TYPE_WEBSERVICE = 'webService';
export const CONNECTION_TYPE_DAV = 'dav';
export const CONNECTION_TYPE_UDCX = 'udcx';
export const CONNECTION_TYPE_ADO = 'ado';
export const CONNECTION_TYPE_SHPLISTFORM = 'shpListForm';

const ELEMENT_NAME_TYPE_MAP = {
    adoAdapter: CONNECTION_TYPE_ADO,
    davAdapter: CONNECTION_TYPE_DAV,
    sharepointListAdapterRW: CONNECTION_TYPE_SHPLIST,
    webServiceAdapter: CONNECTION_TYPE_WEBSERVICE,
    xmlFileAdapter: CONNECTION_TYPE_XMLFILE,
};

export const elementNameToType = compose(
    defaultTo(''),
    prop(__, ELEMENT_NAME_TYPE_MAP),
);